export const GET_ACCOUNTING_TAB_MENU_ITEMS = "GET_ACCOUNTING_TAB_MENU_ITEMS"
export const CREATE_ACCOUNTING_TAB_MENU_ITEMS = "CREATE_ACCOUNTING_TAB_MENU_ITEMS"
export const MINIMIZE_ACCOUNTING_TAB_MENU_ITEMS = "MINIMIZE_ACCOUNTING_TAB_MENU_ITEMS"
export const MAXIMIZE_ACCOUNTING_TAB_MENU_ITEMS = "MAXIMIZE_ACCOUNTING_TAB_MENU_ITEMS"
export const DELETE_ACCOUNTING_TAB_MENU_ITEMS = "DELETE_ACCOUNTING_TAB_MENU_ITEMS"
